"use strict";

exports.__esModule = true;
exports.AdvancedStripeChartDataProvider = AdvancedStripeChartDataProvider;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _InstantaneousEvent = require("../../InstantaneousEvent");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _AdvancedTimelineQueryController = require("../../Timeline/AdvancedTimelineQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AdvancedStripeChartDataProvider(props) {
  var renderWithInstantaneousEventData = function renderWithInstantaneousEventData(_ref) {
    var content = _ref.content,
      interval = _ref.interval,
      devices = _ref.devices;
    var children = props.children,
      showTickets = props.showTickets,
      showComments = props.showComments,
      showAlerts = props.showAlerts;
    var getInstantaneousEvents = {
      getComments: showComments,
      getTickets: showTickets,
      getAlerts: showAlerts
    };
    return /*#__PURE__*/_react["default"].createElement(_InstantaneousEvent.InstantaneousEventController, _extends({
      devices: devices,
      interval: interval
    }, getInstantaneousEvents), function (instantaneousEventList) {
      return children({
        content: content,
        interval: interval,
        instantaneousEventList: instantaneousEventList
      });
    });
  };
  var renderWithAdvancedTimelineData = function renderWithAdvancedTimelineData(devices, interval) {
    var timeline = props.timeline,
      left = props.x,
      top = props.y,
      width = props.width,
      height = props.height;
    var style = {
      top: top,
      left: left,
      width: width,
      height: height
    };
    return /*#__PURE__*/_react["default"].createElement(_AdvancedTimelineQueryController.AdvancedTimelineQueryController, {
      timelineName: timeline,
      interval: interval,
      body: {
        entity: {
          device: devices
        }
      }
    }, function (response) {
      if (response.error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          style: style,
          error: response.error
        });
      }
      if (response.fetching) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      var content = response.data ? response.data : null;
      return renderWithInstantaneousEventData({
        content: content,
        interval: interval,
        devices: devices
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_TimePeriodController.TimePeriodController, {
    dataRange: props.dataRange
  }, function (timePeriod) {
    return /*#__PURE__*/_react["default"].createElement(_SelectedDevicesController.SelectedDevicesController, null, function (devices) {
      return /*#__PURE__*/_react["default"].createElement("div", null, renderWithAdvancedTimelineData(devices, timePeriod.interval));
    });
  });
}